export const TV_MENU_ITEMS = [
  { label: "Produções", to: "/ranking/producao" },
  { label: "Montagens", to: "/ranking/montagem" },
  { label: "Entregas", to: "/ranking/entregas" },
  { label: "Retiradas", to: "/ranking/retirada" },
  { label: "Ficha Diária", to: "/ranking/ficha-diaria" },
  { label: "Setores", to: "/ranking/ficha-setores" },
  { label: "Metas Coletiva", to: "/ranking/metas-coletiva" },
  { label: "Métricas de Qualidade", to: "/ranking/metricas-qualidade" },
  { label: "Painel Bordeiro", to: "/ranking/painel-bordeiro" },
];

export const TV_MENU_ITEMS_ENTREGADOR = [
  { label: "Entregas", to: "/ranking/entregas" },
];

export const RELATORIOS_MENU_ITEMS = [
  { label: "Todos Relatórios", to: "/relatorios" },
  { label: "Pizzas brinde", to: "/relatorios/pizzas-brinde" },
  { label: "Pizzas em promoções", to: "/relatorios/pizzas-promocoes" },
  { label: "Pedidos por bairro", to: "/relatorios/pedidos-por-bairro" },
  { label: "Bebidas", to: "/relatorios/bebidas" },
  { label: "Pizzas por sabor", to: "/relatorios/pizzas-por-sabor" },
  { label: "Pizzas por tamanho", to: "/relatorios/pizzas-por-tamanho" },
  { label: "Rodízio de Pizzas", to: "/relatorios/rodizio-pizzas" },
  { label: "Pizzas Salão", to: "/relatorios/salao-pizzas" },
  { label: "Bebidas Salão", to: "/relatorios/salao-bebidas" },
];

export const FUNCOES_MENU_ITEMS = [
  { label: "Produção", to: "/pizzaiolo" },
  { label: "Produção Integração", to: "/pizzaiolo-integracao" },
  { label: "Produção Porções", to: "/producao-porcoes" },
  { label: "Produção Bebidas", to: "/producao-bebidas" },
  { label: "Forno", to: "/forneiro" },
  { label: "Entregadores", to: "/entregadores" },
  { label: "Bordeiros", to: "/bordeiro" },
  { label: "Painel Bordeiro", to: "/painel-bordeiro" },
];

export const ROTEIRIZACAO_MENU_ITEMS = [
  { label: "Roteirista", to: "/roterista" },
  { label: "Roteirista Automático", to: "/roterista-automatico" },
];

export const UNGROUPED_MAIS_TITLES: Record<string, string> = {
  "/lojas": "Unidades",
  "/inspecao": "Unidades",
  "/whatsapp": "Comunicação",
};
